// extracted by mini-css-extract-plugin
module.exports = {"button":"SliderButton_button__9oW9a","prev":"SliderButton_prev__7sKgY","icon":"SliderButton_icon__8jp_O","next":"SliderButton_next__22ve9"};